import { useEffect, useState } from "react";
import api from "../lib/api";

let _cache = null;
let _pending = null;

export function useSiteSettings() {
    const [settings, setSettings] = useState(_cache);
    const [loading, setLoading] = useState(!_cache);

    useEffect(() => {
        if (_cache) {
            setSettings(_cache);
            setLoading(false);
            return;
        }
        if (!_pending) {
            _pending = api.get("/settings/site").then(({ data }) => {
                _cache = data;
                return data;
            });
        }
        let mounted = true;
        _pending
            .then((data) => {
                if (!mounted) return;
                setSettings(data);
                setLoading(false);
            })
            .catch(() => {
                if (!mounted) return;
                setLoading(false);
            });
        return () => {
            mounted = false;
        };
    }, []);

    const refresh = async () => {
        try {
            const { data } = await api.get("/settings/site");
            _cache = data;
            setSettings(data);
            return data;
        } catch (e) {
            return null;
        }
    };

    return { settings, loading, refresh };
}

export function invalidateSiteSettings() {
    _cache = null;
    _pending = null;
}
